import { distanceInMeters } from "@citychallenge/common";
import { GeoLocationEvent } from "../services/geo";

export function sortCoordinates(
  event: GeoLocationEvent | undefined,
  coordinates: number[][]
) {
  if (!event) return undefined;

  const { latitude, longitude } = event.coords;

  const userLocation = [longitude, latitude];
  const sorted = coordinates.slice().sort((a, b) => {
    return distanceInMeters(a, userLocation) < distanceInMeters(b, userLocation)
      ? -1
      : 1;
  });

  return {
    userLocation,
    sorted,
  };
}
